
<script>
export default {
  name: "ui",
  props: {
    u: { type: Object },
    element: { type: String },
    attrs: { type: Object },
    styles: { type: Object },
    classes: { type: Object },
    props: { type: Object },
  },
  data() {
    return { key: "" };
  },
  methods: {
    createcomponent(name, type) {
      return this.$vue.component(name, {
        functional: true,
        render: function (createElement, context) {
          createElement(type, context.data, context.children);
          return (this.made = name);
        },
      });
    },
  },
  render: function (h) {
    var u = this.u ||{};
    let renderObj = {
      attrs: this.attrs || u.attrs || {},
      style: this.styles || u.styles || {},
      class: this.classes || u.classes || {},
      domProps: this.props || u.props || {
        innerHTML: u.text,
      },
    };
    renderObj.attrs.ref = Date.now();
    if (u.text) renderObj.domProps = { innerHTML: u.text };
    if (u.method) {
      renderObj.on = { click: () => this.$store[u.method[0]](u.method[1]) };
    }
    return h(this.element || u.element || 'div', renderObj);
  },
};
</script>

